'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RenderText2 = require('./RenderText');

var _RenderText3 = _interopRequireDefault(_RenderText2);

var _RenderSummaryResults = require('./RenderSummaryResults');

var _RenderSummaryResults2 = _interopRequireDefault(_RenderSummaryResults);

var _RenderWarnings = require('./RenderWarnings');

var _RenderWarnings2 = _interopRequireDefault(_RenderWarnings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderSummary = function (_RenderText) {
  _inherits(RenderSummary, _RenderText);

  function RenderSummary() {
    _classCallCheck(this, RenderSummary);

    return _possibleConstructorReturn(this, (RenderSummary.__proto__ || Object.getPrototypeOf(RenderSummary)).apply(this, arguments));
  }

  _createClass(RenderSummary, [{
    key: 'mountResults',
    value: function mountResults() {
      var _props = this.props,
          results = _props.results,
          exampleResults = _props.exampleResults;

      var isShowResults = this.props.data.get('showResults');
      if (!isShowResults) return null;
      var data = results && results.length ? results : exampleResults;

      return _react2.default.createElement(_RenderSummaryResults2.default, { data: data });
    }
  }, {
    key: 'mountPanels',
    value: function mountPanels() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var opts = Object.assign({ withImage: false }, options);
      var panels = _RenderText3.default.prototype.mountPanels.call(this);
      var container = panels;
      var containerChildren = container.props.children;

      if (opts.withImage) {
        var textPanel = containerChildren[0];
        var textPanelChildren = textPanel.props.children;
        var textPanelChildrenBlocks = [].concat(textPanelChildren)[0].props.children;

        var newTextPanelComponent = _react2.default.cloneElement(textPanel, { key: Math.random() }, [textPanelChildrenBlocks[0].insert(textPanelChildrenBlocks[0].size, this.mountResults())].concat(_toConsumableArray(textPanelChildrenBlocks.slice(1, textPanelChildrenBlocks.length))));

        var newContainer = _react2.default.cloneElement(container, null, [_react2.default.createElement('div', { className: 'wsequiz_content' }, [newTextPanelComponent])].concat(_toConsumableArray(containerChildren.slice(1, containerChildren.length))));

        return newContainer;
      }

      return _react2.default.cloneElement(container, null, [containerChildren[0].insert(containerChildren[0].size, this.mountResults())].concat(_toConsumableArray(containerChildren.slice(1, containerChildren.length))));
    }
  }, {
    key: 'render',
    value: function render() {
      var panelOptions = { withImage: Boolean(this.props.data.get('image')) };

      return _react2.default.createElement(
        'div',
        { ref: this.props.measureRef, className: this.props.className },
        _react2.default.createElement(_RenderWarnings2.default, this.props),
        this.mountPanels(panelOptions)
      );
    }
  }]);

  return RenderSummary;
}(_RenderText3.default);

exports.default = RenderSummary;
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderSummary.js
// module id = 803
// module chunks = 0